import Route from '@ember/routing/route';

export interface VisitDebugWorkflowModel {
  visitableId: string;
}

export default class VisitorsVisitDebugWorkflowRoute extends Route {
  model(params: { visitable_id: string }): VisitDebugWorkflowModel {
    return { visitableId: params.visitable_id };
  }
}
